<template>
    <Modal v-if="showModal" :allowClose="true" @modal:close="closeModal" :maxWidth="'max-w-[691px]'" :hideActions="true" :preventScrolling="false">
        <template #body>
            <div class="px-8 pb-[44px] font-Inter">
                <div>
                    <div class="flex justify-center">
                        <SuccessIllustration v-if="success"/> 
                        <FailedIcon v-else/>
                    </div>

                    <div class="mt-7 text-center">
                        <h2 class="text-[24px] leading-[34px] font-semibold text-won-blue">
                            <span v-if="success">Success! Your resume is uploaded.</span>
                            <span v-else>Failed to upload your resume</span>
                        </h2>

                        <p class="text-[14px] leading-[17px] text-center text-[#182333] mt-3">
                            <span v-if="success">Your resume has been formatted to Wonsulting's template. Please note for best results, you may need to fine-tune some details</span>
                            <span v-else>There was an error uploading your resume, please try with another file.</span>
                        </p>
                    </div>

                    <button
                        class="w-full bg-won-green rounded py-[9.5px] border-won-green text-white mt-9"
                        @click="emit('view-resume')"
                        v-if="success"
                    >
                        View Resume<span v-if="keepOriginalFormat">s</span>
                    </button>

                    <button
                        class="w-full bg-won-green rounded py-[9.5px] border-won-green text-white mt-9"
                        @click="closeModal()"
                        v-else
                    >
                        Close
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>
  
<script setup>
import Modal from "../../components/modal";

import SuccessIllustration from "../../icons/success-apply.vue"
import FailedIcon from "../../icons/failed-application-icon.vue"

const emit = defineEmits(['view-resume'])
const props = defineProps({
    showModal: {
        type: Boolean,
        default: false,
        required: true
    },
    closeModal: {
        type: Function,
        required: true
    },
    success: {
        type: Boolean,
        default: true
    },
    keepOriginalFormat: {
        type: Boolean,
        default: true
    }
})
</script>
